// eslint-disable-next-line
module.exports = require('./dist/es5/debug');



//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/debug.js
// module id = 1551
// module chunks = 0